module.exports = __webpack_public_path__ + "static/Acta-Book-d093b7fb27456e54af1c3335c4ebd9f1.woff2";